/**
 * 几何对象类型枚举。
 */
export enum GeometryType {
  /** 草图几何。 */
  SKETCH = 'sketch',
  /** 实体几何。 */
  SOLID = 'solid',
  /** 曲面几何。 */
  SURFACE = 'surface',
  /** 边几何。 */
  EDGE = 'edge',
  /** 面几何。 */
  FACE = 'face',
  /** 顶点几何。 */
  VERTEX = 'vertex',
  /** 曲线几何。 */
  CURVE = 'curve',
}
